const colorPalette = [
  {
    borderColor: "rgba(255, 99, 132, 1)",
    backgroundColor: "rgba(255, 99, 132, 0.2)",
  },
  {
    borderColor: "rgba(54, 162, 235, 1)",
    backgroundColor: "rgba(54, 162, 235, 0.2)",
  },
  {
    borderColor: "rgba(255, 206, 86, 1)",
    backgroundColor: "rgba(255, 206, 86, 0.2)",
  },
];

export const plotDefinitions = [
  {
    value: "temperature",
    label: "Temperature",
    unit: "°C",
    series: [
      { key: "tempHigh", label: "High Temp" },
      { key: "tempLow", label: "Low Temp" },
      { key: "tempAvg", label: "Avg Temp" },
    ],
  },
  {
    value: "windSpeed",
    label: "Wind Speed",
    unit: "km/h",
    series: [
      { key: "windspeedHigh", label: "High Wind Speed" },
      { key: "windspeedLow", label: "Low Wind Speed" },
      { key: "windspeedAvg", label: "Avg Wind Speed" },
    ],
  },
  {
    value: "windGust",
    label: "Wind Gust",
    unit: "km/h",
    series: [
      { key: "windgustHigh", label: "High Wind Gust" },
      { key: "windgustLow", label: "Low Wind Gust" },
      { key: "windgustAvg", label: "Avg Wind Gust" },
    ],
  },
  {
    value: "dewPoint",
    label: "Dew Point",
    unit: "°C",
    series: [
      { key: "dewptHigh", label: "High Dew Point" },
      { key: "dewptLow", label: "Low Dew Point" },
      { key: "dewptAvg", label: "Avg Dew Point" },
    ],
  },
  {
    value: "windChill",
    label: "Wind Chill",
    unit: "°C",
    series: [
      { key: "windchillHigh", label: "High Wind Chill" },
      { key: "windchillLow", label: "Low Wind Chill" },
      { key: "windchillAvg", label: "Avg Wind Chill" },
    ],
  },
  {
    value: "heatIndex",
    label: "Heat Index",
    unit: "°C",
    series: [
      { key: "heatindexHigh", label: "High Heat Index" },
      { key: "heatindexLow", label: "Low Heat Index" },
      { key: "heatindexAvg", label: "Avg Heat Index" },
    ],
  },
  {
    value: "precipitation",
    label: "Precipitation",
    unit: "mm",
    series: [
      { key: "precipRate", label: "Precipitation Rate" },
      { key: "precipTotal", label: "Precipitation Total" },
    ],
  },
].map((plot) => ({
  ...plot,
  series: plot.series.map((item, index) => ({
    ...item,
    ...colorPalette[index % colorPalette.length],
  })),
}));

export function buildEmptyHistoricalSeries(days) {
  return plotDefinitions.reduce((accumulator, plot) => {
    accumulator[plot.value] = plot.series.map((series) => ({
      ...series,
      data: Array(days).fill(null),
    }));
    return accumulator;
  }, {});
}
